import Constants from '../constants';
import produce from "immer";
import { UpdateArray, ChangeOrder, UpdateArrayRange } from '../misc/ArrayFuncs';
const initDataState = null;
//Not Normalized
const AlertAction = (state = initDataState, action) => {
    switch (action.type) {
        case Constants.Actions.AlertAction.Alert:
            return action.confirmObj;
        case Constants.Actions.AlertAction.ClearData:
            return initDataState;
        default:
            return state;
    };
}
export default AlertAction;